import { ENVIRONMENT, environment } from "@/lib/environment";

const ENVIRONMENT_TO_MATOMO_URL: Record<ENVIRONMENT, string | undefined> = {
  development: import.meta.env.VITE_MATOMO_URL_DEV as string,
  test: import.meta.env.VITE_MATOMO_URL_DEV as string,
  staging: import.meta.env.VITE_MATOMO_URL_STAGING as string,
  production: import.meta.env.VITE_MATOMO_URL_PROD as string,
};

const ENVIRONMENT_TO_MATOMO_SITE_ID: Record<ENVIRONMENT, string | undefined> = {
  development: import.meta.env.VITE_MATOMO_SITE_ID_DEV as string,
  test: import.meta.env.VITE_MATOMO_SITE_ID_DEV as string,
  staging: import.meta.env.VITE_MATOMO_SITE_ID_STAGING as string,
  production: import.meta.env.VITE_MATOMO_SITE_ID_PROD as string,
};

export const getMatomoUrl = () => {
  return ENVIRONMENT_TO_MATOMO_URL[environment] ?? "https://matomo.roqua.nl";
};

export const getMatomoSiteId = () => {
  return ENVIRONMENT_TO_MATOMO_SITE_ID[environment] ?? "1";
};
